<template>
  <div class="add-item">
    <h1 class="blue-grey--text text-center my-5">항목 추가하기</h1>
    <form>
      <v-container>
        <v-expansion-panels v-model="panel" multiple focusable>
          <!-- Definition || Story -->
          <v-expansion-panel>
            <v-expansion-panel-header class="blue-grey--text text-h6">
              Definition || Story
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="6" lg="3">
                  <v-text-field
                    v-model="birthYear"
                    label="year of birth"
                    placeholder="1800"
                    prepend-icon="mdi-clock-start"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" lg="3">
                  <v-text-field
                    v-model="deathYear"
                    label="year of death"
                    placeholder="1900"
                    prepend-icon="mdi-clock-end"
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" lg="3">
                  <v-text-field
                    v-model="eventStart"
                    label="starting day of event"
                    placeholder="1781.04.20"
                    prepend-icon="mdi-clock-start"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" lg="3">
                  <v-text-field
                    v-model="eventEnd"
                    label="ending day of event"
                    placeholder="1781.04.23"
                    prepend-icon="mdi-clock-end"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="content"
                    outlined
                    label="Definition or Story"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Semantic Data -->
          <v-expansion-panel>
            <v-expansion-panel-header class="blue-grey--text text-h6">
              Semantic Data
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Node Description -->
              <p class="cyan--text mt-5">Node Description</p>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-if="className == 'Story'"
                    v-model="idNameStory"
                    label="id"
                    prepend-icon="mdi-card-account-details-outline"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    disabled
                    v-model="idName"
                    label="id"
                    prepend-icon="mdi-card-account-details-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="2">
                  <v-select
                    v-model="className"
                    :items="options"
                    label="class"
                    prepend-icon="mdi-group"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                  <v-select
                    v-model="groupName"
                    :items="subOptions"
                    label="groupName"
                    prepend-icon="mdi-tag-outline"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                  <v-text-field
                    v-model="partName"
                    label="partName"
                    prepend-icon="mdi-tag-plus"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    disabled
                    v-model="labelName"
                    label="label"
                    prepend-icon="mdi-label-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="hangeul"
                    label="hangeul"
                    prepend-icon="mdi-chess-king"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="hanja"
                    label="hanja"
                    prepend-icon="mdi-ideogram-cjk"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="english"
                    label="english"
                    prepend-icon="mdi-alpha-r-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-if="className == 'Story'"
                    disabled
                    v-model="infoUrlStory"
                    label="infoUrl"
                    prepend-icon="mdi-link-variant"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    disabled
                    v-model="infoUrl"
                    label="infoUrl"
                    prepend-icon="mdi-link-variant"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="iconUrl"
                    label="iconUrl"
                    prepend-icon="mdi-link-variant"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Contextual Relations -->
              <p class="cyan--text mt-5">
                Contextual Relations
                <popup />
              </p>
              <v-row v-for="(rel, index) in relations" :key="`CR${index}`">
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="relations[index].source"
                    label="source"
                    placeholder="가례도감의례"
                    prepend-icon="mdi-book-open-page-variant-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="relations[index].target"
                    label="target"
                    placeholder="궁중연향"
                    prepend-icon="mdi-target"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-select
                    v-model="relations[index].relation"
                    :items="relationOptions"
                    label="relation"
                    prepend-icon="mdi-relation-one-to-one"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="relations[index].attribute"
                    label="attribute"
                    placeholder="부-녀"
                    prepend-icon="mdi-table-chair"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="7">
                  <v-text-field
                    v-model="relations[index].note"
                    label="attribute"
                    placeholder="고종황제와 명성황후의 능"
                    prepend-icon="mdi-note-text-outline"
                  ></v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" lg="1">
                  <v-btn text small>
                    <v-icon class="purple--text" @click="deleteRelation(rel)">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="source"
                    label="source"
                    placeholder="가례도감의례"
                    prepend-icon="mdi-book-open-page-variant-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="target"
                    label="target"
                    placeholder="궁중연향"
                    prepend-icon="mdi-target"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-select
                    v-model="relation"
                    :items="relationOptions"
                    label="relation"
                    placeholder="creator"
                    prepend-icon="mdi-relation-one-to-one"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="attribute"
                    label="attribute"
                    placeholder="부-녀"
                    prepend-icon="mdi-table-chair"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="7">
                  <v-text-field
                    v-model="note"
                    label="note"
                    placeholder="고종황제와 명성황후의 능"
                    prepend-icon="mdi-note-text-outline"
                  ></v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" lg="1">
                  <v-btn text small @click="addRelation">
                    <v-icon class="blue--text">mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Temporal Resource -->
          <v-expansion-panel v-if="className == 'Event'">
            <v-expansion-panel-header class="blue-grey--text text-h6">
              Temporal Data
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-text-field
                    disabled
                    v-model="idName"
                    label="event_id"
                    placeholder="정해년진찬"
                    prepend-icon="mdi-card-account-details"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="eventLabel"
                    label="event label"
                    placeholder="신정왕후 팔순 잔치"
                    prepend-icon="mdi-label"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    disabled
                    v-model="solar"
                    label="양력"
                    placeholder="1887.02.19 ~ 1887.02.20"
                    prepend-icon="mdi-calendar"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    disabled
                    v-model="lunar"
                    label="음력"
                    placeholder="고종 24.01.27 ~ 고종 24.01.29"
                    prepend-icon="mdi-calendar"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="eventNote"
                    label="note"
                    placeholder="경복궁 만경전"
                    prepend-icon="mdi-map"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Web Resource -->
          <v-expansion-panel>
            <v-expansion-panel-header class="blue-grey--text text-h6">
              Web Resource
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row v-for="(res, index) in webResources" :key="`WR${index}`">
                <v-col cols="12" lg="2">
                  <v-select
                    v-model="res.type"
                    :items="webResourceTypeOptions"
                    label="type"
                    placeholder="해설"
                    prepend-icon="mdi-format-list-bulleted-type"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="res.resource"
                    label="resource"
                    placeholder="한국민족문화대백과사전"
                    prepend-icon="mdi-semantic-web"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="res.title"
                    label="title"
                    placeholder="꽃"
                    prepend-icon="mdi-format-title"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="5">
                  <v-text-field
                    v-model="res.description"
                    label="description/caption"
                    placeholder="description"
                    prepend-icon="mdi-closed-caption-outline"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="res.url"
                    label="url"
                    placeholder="http://encykorea.aks.ac.kr/Contents/Item/E0011255"
                    prepend-icon="mdi-link-variant"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" lg="1">
                  <v-btn text small>
                    <v-icon class="purple--text" @click="deleteResource(res)">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="2">
                  <v-select
                    v-model="webResourceType"
                    :items="webResourceTypeOptions"
                    label="type"
                    placeholder="해설"
                    prepend-icon="mdi-format-list-bulleted-type"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="webResource"
                    label="resource"
                    placeholder="한국민족문화대백과사전"
                    prepend-icon="mdi-semantic-web"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    v-model="webResourceTitle"
                    label="title"
                    placeholder="꽃"
                    prepend-icon="mdi-format-title"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="5">
                  <v-text-field
                    v-model="webResourceDescription"
                    label="description/caption"
                    placeholder="description"
                    prepend-icon="mdi-closed-caption-outline"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-text-field
                    v-model="webResourceUrl"
                    label="URL"
                    placeholder="http://encykorea.aks.ac.kr/Contents/Item/E0018297"
                    prepend-icon="mdi-link-variant"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" lg="1">
                  <v-btn text small @click="addResource">
                    <v-icon class="blue--text">mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Bibliography -->
          <v-expansion-panel>
            <v-expansion-panel-header class="blue-grey--text text-h6">
              Bibliography
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row v-for="(biblio, index) in biblios" :key="`B${index}`">
                <v-col cols="12" lg="2">
                  <v-select
                    v-model="biblio.type"
                    label="type"
                    :items="biblioTypeOptions"
                    placeholder="논문"
                    prepend-icon="mdi-format-list-bulleted-type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" lg="10">
                  <v-text-field
                    v-model="biblio.index"
                    label="bibliographic index"
                    placeholder="지두환, 『고종황제와 친인척』, 역사문화, 2009."
                    prepend-icon="mdi-counter"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="2">
                  <v-text-field
                    v-model="biblio.resource"
                    label="online resource  "
                    placeholder="KCI"
                    prepend-icon="mdi-semantic-web"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="8">
                  <v-text-field
                    v-model="biblio.url"
                    label="url"
                    placeholder="https://academic.naver.com/article.naver?doc_id=177170177"
                    prepend-icon="mdi-link-variant"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" lg="2">
                  <v-btn text small>
                    <v-icon class="purple--text" @click="deleteBiblio(biblio)">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="2">
                  <v-select
                    v-model="biblioType"
                    :items="biblioTypeOptions"
                    label="type"
                    placeholder="논문"
                    prepend-icon="mdi-format-list-bulleted-type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" lg="10">
                  <v-text-field
                    v-model="biblioIndex"
                    label="bibliographic index"
                    placeholder="민덕식, 「명성황후(明成皇后)의 어필(御筆)」, 『忠北史學』 25, 충북대학교 사학회, 2010."
                    prepend-icon="mdi-counter"
                  >
                  </v-text-field>
                  <p class="ml-8 primary--text">
                    ex) 민덕식, 「명성황후(明成皇后)의 어필(御筆)」,
                    『忠北史學』 25, 충북대학교 사학회, 2010.
                  </p>
                </v-col>
                <v-col cols="12" lg="2">
                  <v-select
                    v-model="biblioOnlineResource"
                    :items="biblioOnlineResourceOptions"
                    label="online resource  "
                    placeholder="KCI"
                    prepend-icon="mdi-semantic-web"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" lg="8">
                  <v-text-field
                    v-model="biblioUrl"
                    label="url"
                    placeholder="https://academic.naver.com/article.naver?doc_id=177170177"
                    prepend-icon="mdi-link-variant"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" lg="2">
                  <v-btn text small @click="addBiblio">
                    <v-icon class="blue--text">mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- submit button -->
        <v-row class="justify-center mt-5">
          <v-btn :loading="loading" @click="saveItem" dark color="blue-grey"
            >저장하기</v-btn
          >
        </v-row>
      </v-container>
    </form>
  </div>
</template>

<script>
import { auth } from "../firebase/init";
import { db } from "../firebase/init";
import Popup from "../components/Popup.vue";

export default {
  name: "AddItem",
  components: { Popup },
  data() {
    return {
      panel: [0],
      loading: false,
      user: "",
      content: "",
      birthYear: "",
      deathYear: "",
      eventStart: "",
      eventEnd: "",

      // Semantic Data,
      classAndGroupOptions: [
        {
          className: "Actor",
          groupNames: ["국가", "관서", "기관", "단체", "인물", "인물군"],
        },
        { className: "Event", groupNames: ["사건", "행사", "전시"] },
        {
          className: "Place",
          groupNames: [
            "유적지",
            "근대유적지",
            "장소",
            "소장처",
            "행정지명",
            "자연지명",
            "고지명",
          ],
        },
        { className: "Architecture", groupNames: ["건축", "조형", "건축부품"] },
        { className: "Clothing", groupNames: ["복식", "복장"] },
        { className: "Food", groupNames: ["상차림", "식재료", "음식", "제수"] },
        {
          className: "Object",
          groupNames: [
            "물품",
            "그림",
            "탑본",
            "기장",
            "기념물",
            "현판",
            "화폐",
          ],
        },
        {
          className: "Record",
          groupNames: [
            "문헌",
            "근대문헌",
            "현대문헌",
            "금석문",
            "기사",
            "시각자료",
          ].sort(),
        },
        {
          className: "Work",
          groupNames: ["음악", "연희", "정재", "시", "악장가사"].sort(),
        },
        {
          className: "Concept",
          groupNames: [
            "제도",
            "의례",
            "관직",
            "직역",
            "호칭",
            "개념용어",
            "분류주제",
          ],
        },
        {
          className: "Heritage",
          groupNames: [
            "국보",
            "무형",
            "보물",
            "사적",
            "등록문화재",
            "시도문화재",
          ],
        },
        {
          className: "Multimedia",
          groupNames: ["3D_모델", "3D_지도"],
        },
        {
          className: "WebResource",
          groupNames: [
            "해설",
            "참고",
            "원문",
            "지도",
            "그림",
            "도면",
            "동영상",
            "사진",
          ],
        },
        {
          className: "Text",
          groupNames: ["원문", "번역문", "명문(銘文)"],
        },
        {
          className: "Bibliography",
          groupNames: ["단행본", "논문", "고문헌"],
        },
        { className: "Story", groupNames: ["스토리라인", "에피소드"] },
        { className: "Index", groupNames: ["참고문헌색인", "웹자원색인"] },
      ].sort(function(a, b) {
        var x = a.className.toLowerCase();
        var y = b.className.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      }),
      idNameStory: "",
      className: "",
      groupName: "",
      partName: "",
      hangeul: "",
      hanja: "",
      english: "",

      relationOptions: [
        "hasAdoptedHeir",
        "hasBrother",
        "hasBrotherInLaw",
        "hasConcubine",
        "hasCousin",
        "hasDaughter",
        "hasDaughterInLaw",
        "hasDescendant",
        "hasDisciple",
        "hasFather",
        "hasFatherInLaw",
        "hasGrandDaughter",
        "hasGrandson",
        "hasHusband",
        "hasMaster",
        "hasMother",
        "hasOwner",
        "hasSister",
        "hasSisterInLaw",
        "hasSon",
        "hasSonInLaw",
        "hasSubject",
        "hasWife",
        "isAffinalKinOf",
        "isFellowOf",
        "isLineageKinOf",
        "isMentionedBy",
        "knows",
        "wasOrdainedBy",
        "Relation",
        "annotator",
        "calligrapher",
        "contributor",
        "creator",
        "creatorPresumed",
        "editor",
        "inscriber",
        "publisher",
        "rightsHolder",
        "translator",
        "writer",
        "Relation",
        "hasAffiliation",
        "isMemberOf",
        "member",
        "Relation",
        "servesAs",
        "servesTemporallyAs",
        "wasPosthumouslyPromotedTo",
        "isOfficialPostOf",
        "hasAppointee",
        "Relation",
        "enshrines",
        "isBirthPlaceOf",
        "isDeliveryPlaceOf",
        "isNear",
        "isPlacentaChamberOf",
        "isSiteOf",
        "Relation",
        "isEnshrinedIn",
        "livesIn",
        "wasBuriedIn",
        "wasExecutedAt",
        "currentLocation",
        "formerLocation",
        "isProducedIn",
        "isCurrentlySituatedOn",
        "isLocatedIn",
        "isPreviouslySituatedOn",
        "Relation",
        "happenedAt",
        "isCausedBy",
        "isVictimOf",
        "leads",
        "Relation",
        "administrates",
        "hasParticipant",
        "isHeldAt",
        "isOperatedIn",
        "participatesIn",
        "Relation",
        "appearsIn",
        "hasPerformance",
        "isAwarded",
        "isPerformedAt",
        "isPerformedBy",
        "isPerformedIn",
        "plays",
        "Relation",
        "curates",
        "hasExhibition",
        "hasExhibitionAt",
        "Relation",
        "constructor",
        "hasDrawing",
        "isNamedBy",
        "reconstructor",
        "renovator",
        "founder",
        "Relation",
        "wears",
        "isWornIn",
        "Relation",
        "serves",
        "cooks",
        "prepares",
        "hasIngredient",
        "isGarnishedWith",
        "isProvidedIn",
        "isServedIn",
        "isServedOn",
        "isServedTo",
        "Relation",
        "commemorates",
        "goesWith",
        "hasInscription",
        "isMadeOf",
        "isStoredIn",
        "isUsedIn",
        "Relation",
        "isDepictedIn",
        "isMentionedIn",
        "depicts",
        "documents",
        "hasEpitaph",
        "hasHistoricalSetting",
        "hasText",
        "hasVersion",
        "isPostedIn",
        "mentions",
        "references",
        "isDerivativeOf",
        "isSuccessorOf",
        "provenance",
        "Relation",
        "hasAsset",
        "hasBranchTemple",
        "hasHermitage",
        "isDesignatedAs",
        "isSteleOf",
        "isTombstoneOf",
        "isStupaOf",
        "isTombOf",
        "Relation",
        "hasNewName",
        "hasOldName",
        "isNamedAfter",
        "isNamesakeOf",
        "Relation",
        "hasPart",
        "isInfluencedBy",
        "isKindOf",
        "isPartOf",
        "isRelatedTo",
        "mightBeRelatedTo",
        "sameAs",
        "type",
        "includes",
        "isNextInSequenceTo",
        "isPreviousInSequenceTo",
        "Relation",
        "bibliography",
        "onlineReference",
        "textReference",
        "isShownAt",
        "isShownBy",
        "isReferencedFrom",
        "hasReferenceNote",
        "hasChineseExplanation",
        "hasEnglishExplanation",
      ].sort(),
      relations: [], // [{source: '', target: '', relation: '', attribute: '', note: ''}, {}, {}...]
      source: null,
      target: null,
      relation: null,
      attribute: null,
      note: null,

      // Temporal Data
      eventLabel: "",
      eventNote: "",

      // Web Resource
      webResources: [], // [{}, {}, {}]
      webResourceTypeOptions: [
        "해설",
        "참고",
        "원문",
        "사진",
        "동영상",
        "도면",
        "그림",
        "지도",
        "3D_지도",
        "3D_모델",
      ],
      webResourceType: null,
      webResource: null,
      webResourceTitle: null,
      webResourceDescription: null,
      webResourceUrl: null,

      biblios: [], // [{}, {}, {}]
      biblioType: null,
      biblioTypeOptions: ["단행본", "논문", "도록", "자료집"],
      biblioIndex: null,
      biblioOnlineResource: null,
      biblioOnlineResourceOptions: [
        "KCI",
        "RISS",
        "DBpia",
        "KISS",
        "네이버 학술정보",
      ],
      biblioUrl: null,
    };
  },
  created() {
    let user = auth.currentUser;
    if (user) {
      this.user = {};
      db.collection("users")
        .where("id", "==", user.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.user.name = doc.data().name;
            this.user.alias = doc.data().alias;
            this.user.slug = doc.id;
          });
        });
    } else {
      this.user = null;
    }
  },
  computed: {
    // create options for className
    options() {
      let options = [""];
      this.classAndGroupOptions.forEach((optionGroup) => {
        options.push(optionGroup.className);
      });
      return options;
    },

    // create sub-options for groupName
    subOptions() {
      let subOptions = [];
      this.classAndGroupOptions.forEach((optionGroup) => {
        if (optionGroup.className == this.className) {
          subOptions = optionGroup.groupNames;
        }
      });
      return subOptions;
    },
    idName() {
      let name = this.hangeul;
      name = name.replaceAll(" ", "_");
      return name;
    },
    labelName() {
      if (this.birthYear || this.deathYear) {
        if (this.hanja) {
          return `${this.hangeul}(${this.hanja} ${this.birthYear}~${this.deathYear})`;
        } else {
          return `${this.hangeul}(${this.birthYear}~${this.deathYear})`;
        }
      }
      if (this.eventStart || this.eventEnd) {
        if (this.hanja) {
          return `${this.hangeul}(${this.hanja} ${this.eventStart}~${this.eventEnd})`;
        } else {
          return `${this.hangeul}(${this.eventStart}~${this.eventEnd})`;
        }
      }
      if (this.hanja) {
        return `${this.hangeul}(${this.hanja})`;
      } else {
        return `${this.hangeul}`;
      }

      // if (this.birthYear || this.deathYear) {
      //   return `${this.hangeul}(${this.hanja} ${this.birthYear}~${this.deathYear})`;
      // } else {
      //   if (this.hanja) {
      //     return `${this.hangeul}(${this.hanja})`;
      //   } else {
      //     return `${this.hangeul}`;
      //   }
      // }
    },
    solar() {
      return `${this.eventStart} ~ ${this.eventEnd}`;
    },
    lunar() {
      return `${this.eventStart} ~ ${this.eventEnd}`;
    },
    infoUrl() {
      return `http://dh.aks.ac.kr/hanyang2/wiki/index.php/${this.idName}`;
    },
    iconUrl() {
      return `http://digerati.aks.ac.kr/dhLab/2021/hanyang/image/${this.idName}.jpg`;
    },
    infoUrlStory() {
      return `http://dh.aks.ac.kr/hanyang2/wiki/index.php/${this.idNameStory}`;
    },
  },
  methods: {
    addRelation() {
      if (this.relation) {
        let relation = {
          source: this.source,
          target: this.target,
          relation: this.relation,
          attribute: this.attribute,
          note: this.note,
        };
        this.relations.push(relation);
      }

      this.source = null;
      this.target = null;
      this.relation = null;
      this.attribute = null;
      this.note = null;
    },
    deleteRelation(relation) {
      this.relations = this.relations.filter((rel) => {
        return rel != relation;
      });
    },
    addResource() {
      if (this.webResourceTitle) {
        let resource = {
          type: this.webResourceType,
          resource: this.webResource,
          title: this.webResourceTitle,
          description: this.webResourceDescription,
          url: this.webResourceUrl,
        };
        this.webResources.push(resource);
      }
      this.webResourceType = null;
      this.webResource = null;
      this.webResourceTitle = null;
      this.webResourceDescription = null;
      this.webResourceUrl = null;
    },
    deleteResource(resource) {
      this.webResources = this.webResources.filter((res) => {
        return res != resource;
      });
    },
    addBiblio() {
      if (this.biblioIndex) {
        let biblio = {
          type: this.biblioType,
          index: this.biblioIndex,
          resource: this.biblioOnlineResource,
          url: this.biblioUrl,
        };
        this.biblios.push(biblio);
      }

      this.biblioType = null;
      this.biblioIndex = null;
      this.biblioOnlineResource = null;
      this.biblioUrl = null;
    },
    deleteBiblio(biblio) {
      this.biblios = this.biblios.filter((bib) => {
        return bib != biblio;
      });
    },
    saveItem() {
      // check if className is story or not
      let id = "";
      if (this.className == "Story") {
        id = this.idNameStory;
      } else {
        id = this.idName;
      }

      // Node Description
      const nodeDescription = {
        id: id,
        class: this.className,
        groupName: this.groupName,
        partName: this.partName,
        label: this.labelName,
        hangeul: this.hangeul,
        hanja: this.hanja,
        english: this.english,
        infoUrl: this.infoUrl,
        iconUrl: this.iconUrl,
      };

      // temporal Data
      const temporalData = {
        eventLabel: this.eventLabel,
        note: this.eventNote,
      };

      // add the last Contextual Relation
      if (
        this.source ||
        this.target ||
        this.relation ||
        this.relation ||
        this.attribute ||
        this.note
      ) {
        const relation = {
          source: this.source,
          target: this.target,
          relation: this.relation,
          attribute: this.attribute,
          note: this.note,
        };
        this.relations.push(relation);
      }

      // add the last Web Resource
      if (
        this.webResourceType ||
        this.webResource ||
        this.webResourceTitle ||
        this.webResourceDescription ||
        this.webResourceUrl
      ) {
        const resource = {
          type: this.webResourceType,
          resource: this.webResource,
          title: this.webResourceTitle,
          description: this.webResourceDescription,
          url: this.webResourceUrl,
        };
        this.webResources.push(resource);
      }

      // add the last Bibliograpy
      if (
        this.biblioType ||
        this.biblioIndex ||
        this.biblioOnlineResource ||
        this.biblioUrl
      ) {
        const biblio = {
          type: this.biblioType,
          index: this.biblioIndex,
          resource: this.biblioOnlineResource,
          url: this.biblioUrl,
        };
        this.biblios.push(biblio);
      }

      // save the item into Database
      if (this.idName) {
        this.loading = true;
        db.collection("items")
          .add({
            user: this.user,
            birthYear: this.birthYear,
            deathYear: this.deathYear,
            eventStart: this.eventStart,
            eventEnd: this.eventEnd,
            content: this.content,
            nodeDescription: nodeDescription,
            temporalData: temporalData,
            contextualRelation: this.relations,
            webResources: this.webResources,
            bibliography: this.biblios,
            timestamp: Date.now(),
          })
          .then(() => {
            this.loading = false;
            this.$router.push({ name: "Projects" });
          });
      }
    },
  },
};
</script>

<style>
.v-select__selection,
.v-text-field__slot input {
  color: #ad1457 !important;
}
</style>
